import ChartBase from "./ChartBase";
import Chart from 'chart.js';
import { colors, radarRatings } from "./theme";
export class RadarChart extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // always call this
            this._getElements();
        };
        this.updateData = (props) => {
            // get correct props
            var correctProps = props;
            // test combined props
            if (props.chartData) {
                correctProps = props.chartData;
            }
            // set metric and question
            this._setBaseInfo(props);
            // get data and labels
            let { data, rawData, labels, backgroundColors } = correctProps;
            // store data
            this.data = data;
            this.rawData = rawData;
            // background colors
            if (!backgroundColors || backgroundColors.length <= 0) {
                // calculate color base on rating
                backgroundColors = data.map(rating => this._getRatingColors(rating));
            }
            // format labels
            const formattedLabels = this._formatLabels(labels);
            // update data if chart instance exist
            if (this.chart) {
                this.chart.data.datasets[0].data = data;
                // render
                this.chart.update();
            }
            // initiate chart instance
            else {
                this.chart = new Chart(this.ctx, {
                    type: 'radar',
                    data: {
                        labels: formattedLabels,
                        datasets: [{
                                data: data,
                                backgroundColor: "rgba(49,49,49,0.05)",
                                borderColor: colors.mutedLight,
                                borderWidth: 3,
                                pointRadius: 9,
                                pointBorderColor: colors.transparent,
                                pointHoverBorderColor: colors.transparent,
                                pointHoverRadius: 9,
                                pointBorderWidth: 0,
                                pointHoverBorderWidth: 0,
                                pointBackgroundColor: backgroundColors,
                                spanGaps: true
                            }],
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        maintainAspectRatio: false,
                        scale: {
                            ticks: {
                                display: false,
                                min: 0,
                                max: 7,
                                beginAtZero: true,
                                fontColor: colors.muted
                            },
                            gridLines: {
                                color: colors.gridLineColor
                            },
                            pointLabels: {
                                fontSize: 13,
                                fontColor: colors.muted
                            }
                        },
                        tooltips: {
                            callbacks: {
                                title: (item, data) => {
                                    const Indexes = item.map(i => i.index);
                                    // get labels
                                    const label = labels.find((label, index) => Indexes.includes(index));
                                    return label;
                                },
                                label: (tooltipItem, data) => {
                                    var label = radarRatings[tooltipItem.value];
                                    // show raw data out of total
                                    if (label) {
                                        label += ':';
                                    }
                                    if (this.rawData) {
                                        const total = rawData.reduce(function (a, b) {
                                            return a + b;
                                        }, 0);
                                        label += ` ${this.rawData[tooltipItem.index]}/${total}`;
                                    }
                                    else {
                                        // default
                                        label += ` ${tooltipItem.value}`;
                                    }
                                    //console.log(tooltipItem);
                                    //console.log(this.rawData);
                                    //console.log(tooltipItem.index);
                                    //console.log(this.rawData[tooltipItem.index]);
                                    return label;
                                }
                            }
                        }
                    }
                });
                // generate legend by rating colors
                var legendHtml = [];
                //this is 1 based, so we skip the "no response" scenario
                for (var i = 1; i < colors.ratingColors.length; i++) {
                    // create legend item
                    const div = document.createElement("div");
                    div.className = "legend-item";
                    div.setAttribute("data-id", i.toString());
                    // create legend
                    const spanLegend = document.createElement("span");
                    spanLegend.className = "legend-item-color";
                    spanLegend.style.backgroundColor = colors.ratingColors[i];
                    // create legend text
                    const spanText = document.createElement("span");
                    spanText.className = "legend-item-text";
                    spanText.textContent = radarRatings[i];
                    // add to legend item
                    div.appendChild(spanLegend);
                    div.appendChild(spanText);
                    legendHtml.push(div.outerHTML);
                }
                this.legendElement.innerHTML = legendHtml.join("");
                // add legend filter event
                const legends = [].slice.call(this.legendElement.querySelectorAll(".legend-item"));
                legends.forEach(legendItem => {
                    legendItem.addEventListener("click", () => {
                        this._filterLegend(legendItem);
                    });
                });
            }
            // remove loading
            this.loading = false;
        };
        this._filterLegend = (legendItem) => {
            // set status
            legendItem.classList.toggle("hidden");
            // get all hidden value
            const hiddenIndexes = [].slice.call(this.legendElement.querySelectorAll(".legend-item.hidden"))
                .map((legend) => parseInt(legend.getAttribute("data-id")));
            // recalculate colors base on new value
            const backgroundColors = this.data.map(rating => {
                if (hiddenIndexes.includes(rating)) {
                    return colors.transparent;
                }
                return this._getRatingColors(rating);
            });
            // filter color
            this.chart.data.datasets[0].pointBackgroundColor = backgroundColors;
            // render
            this.chart.update();
        };
        this._getRatingColors = (rating) => {
            return colors.ratingColors[rating];
        };
        this._formatLabels = (labels) => {
            const maxCharacterPerRow = 15;
            var regex = '.{1,' + maxCharacterPerRow + '}(\\s|$)|\\S+?(\\s|$)';
            const formattedLabels = [];
            // wrap label
            labels.forEach((label, index) => {
                formattedLabels.push(label.match(RegExp(regex, 'g')).map(item => item.trim()));
            });
            return formattedLabels;
        };
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                <div class="dashboard-charts-graph">
                    <canvas />
                </div>
                <div class="dashboard-charts-legend" data-legend>&nbsp; &nbsp;</div>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-radar-chart", RadarChart);
